
<script>
export default {
  name: 'description',
  props: {
    description: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    showFullDescription: false
  })
}
</script>

<template>
  <div class="cart__hotel-description">
    <p
      v-if="showFullDescription"
      v-html="description.full"
    />
    <p v-else>
      {{ description.short }}
    </p>
    <span
      @click="showFullDescription = !showFullDescription"
    >
      {{ showFullDescription ? 'Свернуть' : 'Читать еще' }}
    </span>
  </div>
</template>
